/* @flow */
import Group from 'entities/Group';

export const STUDENT = 'student';
export const PARENT = 'parent';
export const ADMIN = 'admin';
export const TEACHER = 'teacher';
export const UNKNOWN = 'unknown';
export const EVERYONE = 'everyone';
export const RCE = 'rce';

export const subgroupName = {
  [STUDENT]: 'Students',
  [PARENT]: 'Parents',
  [ADMIN]: 'Administrators',
  [TEACHER]: 'Teachers',
  [EVERYONE]: 'Everyone',
};

export const roleName = {
  [STUDENT]: 'Students',
  [PARENT]: 'Parents',
  [ADMIN]: 'Administrators',
  [TEACHER]: 'Teachers',
  [EVERYONE]: 'Everyone',
  [UNKNOWN]: 'No role',
};

export const roleNameSingular = {
  [STUDENT]: 'Student',
  [PARENT]: 'Parent',
  [ADMIN]: 'Admin',
  [TEACHER]: 'Teacher',
};

export const getGroupDescription = (group: Group, role: ?string) => {
  const name = group.getName();
  if (!role || role === EVERYONE) {
    return name;
  } else {
    return `${name} ${String.fromCharCode(160) + String.fromCharCode(8250) +
      String.fromCharCode(160)} ${subgroupName[role]}`;
  }
};

export const getGroupKey = (groupId: number, role: string = EVERYONE): string => { // eslint-disable-line
  return `${groupId}${role === EVERYONE ? '' : role}`;
};



// WEBPACK FOOTER //
// ./src/utils/roleHelpers.js